<template>
  <div>
    <h3 class="booth-subheader">Booth Representatives</h3>

    <p>Click on a Booth Representative to view their details and to schedule a meeting</p>

    <div class="agenda-speakers-wrapper">
      <ul class="agenda-detail-presenters">
        <li
          v-for="(speaker, index) in boothRepresentatives"
          :key="index"
        >
          <speaker-short-card
            :name="speaker.full_name"
            :title="speaker.title"
            :photo="speaker.photo_url"
            @click.native="onOpenPresenterModal(speaker)"
          />
        </li>
      </ul>
    </div>

    <booth-presenter-modal
      :show-modal.sync="showPresenterModal"
      :presenter="presenter"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SpeakerShortCard from "../../../components/speakers/SpeakerShortCard/index";
import BoothPresenterModal from './booth-presenter-modal.vue'
import ExhibitContentModal from './exhibit-content-modal.vue'

export default {
  components: {
    ExhibitContentModal,
    BoothPresenterModal,
    SpeakerShortCard,
  },
  mounted() {},
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,

      presenter: {},
      showPresenterModal: false,
    }
  },
  computed: {
    ...mapGetters('boothStore', [
      'boothRepresentatives'
    ]),
  },
  methods: {
    onOpenPresenterModal(presenter) {
      this.presenter = presenter;
      this.showPresenterModal = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.agenda-detail-presenters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0 !important;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }

  li {
    list-style: none !important;
  }
}


.agenda-speakers-wrapper {
  margin-top: 20px;

  li {
    list-style: none;
  }

}

.agenda-speakers {
  padding: 0 0 var(--attendee-gap-sm) 0;
  max-width: 100%;
  width: auto;
}

.booth-subheader {
  margin-bottom: 15px;
}
</style>
